import React from "react";
import SystemLabel from "../../../../system/SystemLabel/SystemLabel";
import ViewStreamOutlinedIcon from "@material-ui/icons/ViewStreamOutlined";
import OndemandVideoOutlinedIcon from "@material-ui/icons/OndemandVideoOutlined";
import EventIcon from "@material-ui/icons/Event";
import ImageOutlinedIcon from "@material-ui/icons/ImageOutlined";
import EventNoteOutlinedIcon from "@material-ui/icons/EventNoteOutlined";
import EventSeatOutlinedIcon from "@material-ui/icons/EventSeatOutlined";
import ViewCarouselOutlinedIcon from "@material-ui/icons/ViewCarouselOutlined";
import AssignmentIndOutlinedIcon from "@material-ui/icons/AssignmentIndOutlined";
import ContactsOutlinedIcon from "@material-ui/icons/ContactsOutlined";
import HelpOutlineOutlinedIcon from "@material-ui/icons/HelpOutlineOutlined";
import CodeOutlinedIcon from "@material-ui/icons/CodeOutlined";
import RecordVoiceOverOutlinedIcon from "@material-ui/icons/RecordVoiceOverOutlined";
import PermIdentityOutlinedIcon from "@material-ui/icons/PermIdentityOutlined";
import StorefrontOutlinedIcon from "@material-ui/icons/StorefrontOutlined";
import ChatBubbleOutlineOutlinedIcon from "@material-ui/icons/ChatBubbleOutlineOutlined";
import KeyboardBackspaceOutlinedIcon from "@material-ui/icons/KeyboardBackspaceOutlined";
import PollOutlinedIcon from "@material-ui/icons/PollOutlined";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import DeleteOutlineOutlinedIcon from "@material-ui/icons/DeleteOutlineOutlined";
import ReplayOutlinedIcon from "@material-ui/icons/ReplayOutlined";
import SubjectIcon from "@material-ui/icons/Subject";
import WidgetsIcon from "@material-ui/icons/Widgets";
import PieChartIcon from "@material-ui/icons/PieChart";
import GroupIcon from "@material-ui/icons/Group";
import TimerIcon from "@material-ui/icons/Timer";
import { Avatar, IconButton, ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import MoreHorizOutlinedIcon from "@material-ui/icons/MoreHorizOutlined";
import ZoomIcon from "./zoomIcon.svg";
import SettingsOutlinedIcon from "@material-ui/icons/SettingsOutlined";
import LiveTvOutlinedIcon from "@material-ui/icons/LiveTvOutlined";
import SettingsList from "../../../../cms/areas/template/components/SettingsList";
import { Button, Col, Row } from "reactstrap";
import { PopList } from "../../../../interaction/moderator/Layout/components/other/PopList";
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver";
import AccountBoxIcon from '@material-ui/icons/AccountBox';


export const ModulePlaceholder = (props) => {
  const { type, displayName = "", customStyle = null, description, blocked = false, module = null, created = false, onSelect = () => null, onAdd = () => null, tab } = props;
  return (
    <div
      style={
        customStyle || {
          display: "flex",
          flexDirection: "column",
          textAlign: "center",
        }
      }
      className={"module-box " + (blocked ? "editor-li blocked-module" : "editor-li")}
    >
      <ListItemAvatar>
        <Avatar style={{ backgroundColor: getAvatarColor(type), margin: "auto" }}>{getModuleIcon(type)}</Avatar>
      </ListItemAvatar>
      <div>
        <div className="primary-text list-text ellipsis">{displayName ? displayName : <SystemLabel name={type} />}</div>
        <div className="secondary-text list-text-small ellipsis">{displayName ? <SystemLabel name={type} /> : ""}</div>
        {/*        {description ? <div className="secondary-text list-text-small ellipsis">{description}</div> : null} */}
      </div>

      {module && module.deleted ? <DeleteOutlineOutlinedIcon className="primary-text module-box-deleted" /> : null}
      {tab == "MyModules" ? (
        <div className="module-box-settings">
          <ModuleOptions {...props} />
        </div>
      ) : null}
    </div>
  );
};

const getModuleIcon = (component) => {
  switch (component) {
    case "Image":
      return <ImageOutlinedIcon />;
    case "Breakouts":
      return <EventSeatOutlinedIcon />;
    case "Agenda":
      return <EventNoteOutlinedIcon />;
    case "Carousel":
      return <ViewCarouselOutlinedIcon />;
    case "SpeakerControl":
      return <RecordVoiceOverIcon />;
    case "ZoomFrame":
      return <img src={ZoomIcon} style={{ height: 40, width: 40 }} />;
    case "ClientFrame":
      return <PollOutlinedIcon />;
    case "JitsiFrame":
      return <img src="https://www.codegram.com/blog/communication-tools/jitsi.png" style={{ height: 30, width: 30 }} />;
    case "CountdownModule":
      return <TimerIcon />;
    case "Video":
      return <OndemandVideoOutlinedIcon />;
    case "UserCard":
      return <AssignmentIndOutlinedIcon />;
    case "ButtonModule":
      return <KeyboardBackspaceOutlinedIcon />;
    case "TextModule":
      return <SubjectIcon />;
    case "BlockModule":
      return <WidgetsIcon />;
    case "Chat":
      return <ChatBubbleOutlineOutlinedIcon />;
    case "Exhibitors":
      return <StorefrontOutlinedIcon />;
    case "Connections":
      return <PermIdentityOutlinedIcon />;
    case "SpeakerSign":
      return <RecordVoiceOverOutlinedIcon />;
    case "GroupGenerator":
      return <GroupIcon />;
    case "ClientList":
      return <ContactsOutlinedIcon />;
    case "Html":
      return <CodeOutlinedIcon />;
    case "Iframe":
      return <LiveTvOutlinedIcon />;
    case "SpeakerCard":
      return <AccountBoxIcon />;
    case "Presenter":
      return <PieChartIcon />;
    case "VonageVideoClientModule":
      return <img src="https://logos.bugcrowdusercontent.com/logos/5589/c34e/b19c9efa/e1aa28a047d9c99d95500c70febcda50_VonageLogo_Symbol_Black__1_.png" style={{ height: 24, width: 24 }} />;
    default:
      return <HelpOutlineOutlinedIcon />;
  }
};
const getAvatarColor = (component) => {
  switch (component) {
    case "Image":
      return "rgb(129 50 170)";
    case "CountdownModule":
      return "rgb(129 50 170)";
    case "Breakouts":
      return "rgb(191 73 55)";
    case "Agenda":
      return "rgb(170 148 45)";
    case "SpeakerControl":
      return "rgb(170 148 45)";
    case "Presenter":
      return "rgb(170 148 45)";
    case "Carousel":
      return "rgb(129 50 170)";
    case "ZoomFrame":
      return "";
    case "PollModule":
      return "rgb(191 73 55)";
    case "JitsiFrame":
      return "#205081";
    case "Video":
      return "rgb(92 141 226)";
    case "UserCard":
      return "rgb(191 73 55)";
    case "ButtonModule":
      return "rgb(129 50 170)";
    case "BlockModule":
      return "rgb(129 50 170)";
    case "TextModule":
      return "rgb(129 50 170)";
    case "Chat":
      return "rgb(41 158 103)";
    case "Exhibitors":
      return "rgb(41 158 103)";
    case "Connections":
      return "rgb(191 73 55)";
    case "SpeakerSign":
      return "rgb(41 158 103)";
    case "GroupGeneratorModule":
      return "rgb(191 73 55)";
    case "ClientList":
      return "rgb(191 73 55)";
    case "Html":
      return "rgb(129 50 170)";
    case "Iframe":
      return "rgb(92 141 226)";
    case "VonageVideoClientModule":
      return "#fff";
    default:
      return "#5a5c6c";
  }
};

/* Video = rgb(92 141 226)
Deltagare = rgb(191 73 55)
Bild = rgb(129 50 170)
Chatt = rgb(41 158 103)
agenda = rgb(170 148 45) */

const ModuleOptions = (props) => {
  const { blocked, created, onSelect, onAdd, module, deleteModule } = props;
  let deleted = module.deleted;
  return (
    <PopList tooltipText={"ModuleOptions"} icon={<MoreHorizOutlinedIcon />}>
      <div className="pop-list dark-l3" style={{ width: 220 }}>
        {!blocked ? (
          <React.Fragment>
            <Row style={{ margin: "0px" }}>
              <Col style={{ padding: "0px" }}>
                <div
                  className="list-option edit"
                  style={{
                    cursor: blocked ? "default" : "pointer",
                    opacity: blocked ? 0.8 : 1,
                  }}
                  onClick={onAdd}
                >
                  <AddIcon className="pop-list-icon" />
                  <SystemLabel name="AddModule" />
                </div>
              </Col>
            </Row>
            <hr className="thin-hr" />
          </React.Fragment>
        ) : null}

        {created ? (
          <Row style={{ margin: "0px" }}>
            <Col style={{ padding: "0px" }}>
              <div
                className="list-option edit"
                style={{
                  cursor: !created ? "default" : "pointer",
                  opacity: !created ? 0.8 : 1,
                }}
                onClick={() => onSelect(module)}
              >
                {" "}
                <SettingsOutlinedIcon className="pop-list-icon" />
                <SystemLabel name="Settings" />
              </div>
            </Col>
          </Row>
        ) : null}
        {created ? (
          <React.Fragment>
            <hr className="thin-hr" />
            <Row style={{ margin: "0px" }}>
              <Col style={{ padding: "0px" }}>
                <div className="list-option edit" onClick={() => deleteModule(module)}>
                  {deleted ? <ReplayOutlinedIcon className="pop-list-icon" /> : <DeleteOutlineOutlinedIcon className="pop-list-icon" />}
                  {deleted ? <SystemLabel name="Undo" /> : <SystemLabel name="Delete" />}
                </div>
              </Col>
            </Row>
          </React.Fragment>
        ) : null}
      </div>
    </PopList>
  );
};
